import { render, staticRenderFns } from "./Compte.vue?vue&type=template&id=20148a57&scoped=true&"
import script from "./Compte.vue?vue&type=script&lang=js&"
export * from "./Compte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20148a57",
  null
  
)

export default component.exports